import React, { Component } from 'react';
import { DataDocumentOperationType } from '../../data/DataDocumentOperationType.jsx';
import { DataDocumentOperationCategorie } from '../../data/DataDocumentOperationCategorie.jsx';
import { Immocom } from '../../specifique/immocom.js';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxDocumentOperationType extends Component {

    static defaultProps = {
        categorie: undefined, idDocumentOperationCategorie: undefined, // L'un ou l'autre : idDocumentOperationCategorie récupéré en BDD via categorie si idDocumentOperationCategorie non renseigné
        label: "Sous-catégorie",
        placeholder: "Sous-catégorie",
    };

    constructor(props) {
        super(props);
        this.state = { idDocumentOperationCategorie: undefined };
    };

    _chargementIdDocumentOperationCategorie = () => {
        this.setState(
            { idDocumentOperationCategorie: undefined },
            () => {
                const { categorie } = this.props;

                DataDocumentOperationCategorie._getDocumentOperationCategorieByName(categorie).then(responseFetch => {
                    const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                    if (retourVerif === null) {
                        const documentReservationCategorie = responseFetch.reponseAPIobjet || {};
                        const { idDocumentOperationCategorie } = documentReservationCategorie;
                        const state = { idDocumentOperationCategorie };
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                    }
                });
            })
    };

    componentDidMount = () => {
        const { categorie, idDocumentOperationCategorie } = this.props;
        if (!!categorie && !idDocumentOperationCategorie)
            this._chargementIdDocumentOperationCategorie();
    };

    componentDidUpdate = (prevProps) => {
        const { categorie } = this.props;
        if (prevProps.categorie !== categorie) {
            if (!!categorie) this._chargementIdDocumentOperationCategorie();
        }
    };

    render = () => {

        const idDocumentOperationCategorie = this.props.idDocumentOperationCategorie || this.state.idDocumentOperationCategorie;

        let fetchMethod = null;
        if (!!idDocumentOperationCategorie)
            fetchMethod = () => DataDocumentOperationType._chargementDesDocumentOperationType(idDocumentOperationCategorie)

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemKey={item => item.idDocumentOperationType}
            itemText={item => item.typeDocument}
            stamp={idDocumentOperationCategorie}
        />;

    };

};